type JSONSchema = {
  $defs?: { [key: string]: JSONSchema };
  $ref?: string;
  [key: string]: any;
};

const resolveRef = (definitions: { [key: string]: JSONSchema }, ref: string): JSONSchema => {
  const refPath = ref.replace(/^#\/\$defs\//, '').split('/');
  let definition: JSONSchema | undefined = definitions;

  for (const segment of refPath) {
    if (!definition || !definition[segment]) {
      throw new Error(`Reference ${ref} is not valid.`);
    }
    definition = definition[segment];
  }

  if (!definition) {
    throw new Error(`Reference ${ref} resolves to undefined.`);
  }

  return definition;
};

const resolveSchema = (schema: JSONSchema, definitions: { [key: string]: JSONSchema }): JSONSchema => {
  const traverse = (obj: any): any => {
    if (Array.isArray(obj)) {
      return obj.map(traverse);
    } else if (typeof obj === 'object' && obj !== null) {
      if (obj.$ref) {
        return traverse(resolveRef(definitions, obj.$ref));
      }

      const newObj: { [key: string]: any } = {};
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          newObj[key] = traverse(obj[key]);
        }
      }
      return newObj;
    }
    return obj;
  };

  return traverse(schema);
};

export const resolveJSONSchema = (schema: JSONSchema): JSONSchema => {
  if (!schema.$defs) {
    throw new Error('No $defs found in the schema.');
  }

  const resolvedSchema = resolveSchema(schema, schema.$defs);
  delete resolvedSchema.$defs;

  return resolvedSchema;
};
